import { render, staticRenderFns } from "./ExtraSettingsSelector.vue?vue&type=template&id=434f2082&"
import script from "./ExtraSettingsSelector.vue?vue&type=script&lang=js&"
export * from "./ExtraSettingsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports